import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { environment } from '@sa/environments/environment';

/**
 * Restricts a route to environments where enableFoundryAgentConfig is true.
 */
export const devEnvironmentGuard: CanActivateFn = (): boolean | UrlTree => {
  const router = inject(Router);
  if ((environment as Record<string, unknown>)['enableFoundryAgentConfig']) {
    return true;
  }
  return router.createUrlTree(['/no-auth']);
};
